'use strict';

const BODY_CLASS = 'w4f-donors-email-modal-open';
const OPEN_SELECTOR = '.selected-emails, .all-selected-emails';
const MENU_BUTTON_SELECTOR =
    '.w4f-account-navigation__toggle, header button.wp-block-navigation__responsive-container-open';
const OPEN_DELAY_MS = 300;

export class MyAccountDonorsEmailModal {
    #pendingOpen = false;
    #allowActive = false;
    #openTimeout = null;

    constructor() {
        const modal = document.getElementById('emailsModal');
        if (!modal) {
            return;
        }

        document.addEventListener(
            'click',
            (event) => {
                if (event.target.closest(OPEN_SELECTOR)) {
                    this.#hideMenuButtons();
                }
            },
            true
        );

        const observer = new MutationObserver(() => this.#handleModalClassChange(modal));
        observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    }

    #handleModalClassChange(modal) {
        const isActive = modal.classList.contains('active');

        if (isActive && this.#allowActive) {
            this.#allowActive = false;
            this.#pendingOpen = false;
            this.#hideMenuButtons();
            return;
        }

        if (isActive) {
            modal.classList.remove('active');
            this.#pendingOpen = true;
            this.#hideMenuButtons();

            window.clearTimeout(this.#openTimeout);
            this.#openTimeout = window.setTimeout(() => {
                this.#allowActive = true;
                modal.classList.add('active');
            }, OPEN_DELAY_MS);

            return;
        }

        if (!this.#pendingOpen) {
            this.#showMenuButtons();
        }
    }

    #hideMenuButtons() {
        document.body.classList.add(BODY_CLASS);
        this.#closeAccountNav();

        document.querySelectorAll(MENU_BUTTON_SELECTOR).forEach((element) => {
            element.style.visibility = 'hidden';
            element.style.pointerEvents = 'none';
        });
    }

    #showMenuButtons() {
        document.body.classList.remove(BODY_CLASS);

        document.querySelectorAll(MENU_BUTTON_SELECTOR).forEach((element) => {
            element.style.visibility = '';
            element.style.pointerEvents = '';
        });
    }

    #closeAccountNav() {
        document.body.classList.remove('w4f-account-nav-open');

        const backdrop = document.querySelector('.w4f-account-navigation__backdrop');
        backdrop?.setAttribute('hidden', '');

        const toggle = document.querySelector('.w4f-account-navigation__toggle');
        toggle?.setAttribute('aria-expanded', 'false');
    }
}
